function a(r, i) {
  if (!r)
    return 0;
  const s = getComputedStyle(r), { transitionProperty: n, transitionDuration: e } = s;
  if (!n || !e)
    return 0;
  const o = n.split(", ").indexOf(i);
  if (o === -1)
    return 0;
  const t = e.split(", "), p = t.length === 1 ? t[0] : t[o];
  return Number.parseFloat(p) || 0;
}
export {
  a as default
};
